import { render, staticRenderFns } from "./Tab1.vue?vue&type=template&id=7a627b10&scoped=true&"
import script from "./Tab1.vue?vue&type=script&lang=ts&"
export * from "./Tab1.vue?vue&type=script&lang=ts&"
import style0 from "./Tab1.vue?vue&type=style&index=0&id=7a627b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a627b10",
  null
  
)

export default component.exports